import { IsEnum, IsNotEmpty, IsString } from "class-validator";

export enum MedicalLeaveSubtypeEnumDto {
    it_common = "it_common",
    it_work_accident = "it_work_accident",
    maternity_paternity = "maternity_paternity",
    pregnancy_risk = "pregnancy_risk",
    other = "other",
}

export class MedicalLeaveSubtypeDto {
    @IsEnum(MedicalLeaveSubtypeEnumDto)
    @IsNotEmpty()
    key!: MedicalLeaveSubtypeEnumDto;

    @IsString()
    @IsNotEmpty()
    value!: string;
}
